export const namespaced = true;

export const state = {
  selectedModule: null,
  currentLesson: null,
  showDrawer: true,
  cardHeight: {},
  maxHeight: 0,
};
export const mutations = {
  selectedModule: (state, payload) => {
    state.selectedModule = payload;
  },
  currentLesson: (state, payload) => {
    state.currentLesson = payload;
  },
  toggleDrawer: (state, payload) => {
    state.showDrawer = payload;
  },
  cardHeight: (state, payload) => {
    state.cardHeight = Object.assign(state.cardHeight, payload);
    let bigger = 0;
    Object.values(state.cardHeight).forEach((element) => {
      if (element > bigger) {
        bigger = element;
      }
    });
    state.maxHeight = bigger;
  },
};
export const getters = {
  selectedModule: (state) => state.selectedModule,
  currentLesson: (state) => state.currentLesson,
  showDrawer: (state) => state.showDrawer,
  cardHeight: (state) => state.cardHeight,
  maxHeight: (state) => state.maxHeight,
};
export const actions = {};
